var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmojiPickerIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "1rem",
    viewBox: "0 0 25.22 25.22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "face-smile-regular",
    d: "M22.856,12.61A10.246,10.246,0,1,0,12.61,22.856,10.246,10.246,0,0,0,22.856,12.61ZM0,12.61A12.61,12.61,0,1,1,12.61,25.22,12.61,12.61,0,0,1,0,12.61Zm8.748,3.059a5.3,5.3,0,0,0,7.724,0,1.182,1.182,0,0,1,1.739,1.6,7.651,7.651,0,0,1-11.191,0,1.182,1.182,0,1,1,1.739-1.6ZM7.113,10.246a1.576,1.576,0,1,1,1.576,1.576A1.576,1.576,0,0,1,7.113,10.246ZM16.57,8.669a1.576,1.576,0,1,1-1.576,1.576A1.576,1.576,0,0,1,16.57,8.669Z",
    fill: "#686868"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmojiPickerIcon);
export default __webpack_public_path__ + "static/media/emoji-picker-icon.6bca5d54769d3644cdc7cd13b076fab0.svg";
export { ForwardRef as ReactComponent };